import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SelectFromConstant } from '../../../components/dropdown-select/SelectFromConstant';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { profileTypes } from '../../../config/constants/userConstants';

const selectableUsers = [profileTypes.TECHNICIAN.id, profileTypes.INTERESTED.id, profileTypes.OPERATOR.id, profileTypes.SUPERVISOR.id];

// Perfiles que cada perfil puede crear (solo inferiores a sí mismo)
const creatableByProfile = {
  [profileTypes.SUPERVISOR.id]: [profileTypes.TECHNICIAN.id, profileTypes.INTERESTED.id, profileTypes.OPERATOR.id],
};

export const SelectUserProfile = ({ value, onChange, multiple , disabled}) => {
  const { translate: t } = useDictionaryTranslation();
  const currentUserProfile = useSelector((state) => state.auth.currentUser?.profile?.idProfile);

  const options = useMemo(() => {
    const allowed = creatableByProfile[currentUserProfile] ?? selectableUsers;
    return Object.values(profileTypes)
      .filter((option) => allowed.includes(option.id))
      .map((option) => ({ ...option, label: t(option.name), value: option.id }));
  }, [t, currentUserProfile]);

  const selectedValue = value && options.find((v) => v.value === value.value);

  return (
    <SelectFromConstant
      value={selectedValue}
      onChange={onChange}
      constantObject={options}
      placeholderText={t('selectTypeUserPlaceholder')}
      multiple={multiple}
      disabled={disabled}
    />
  );
};

SelectUserProfile.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
};
